export const ENDPOINTS = {
  groups: '/groups',
  groupRoles: '/group_roles',
  users: '/users',
  bulkDelete: '/bulk-action/groups/delete',
};
